import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import React from "react";
import nteGen from "../../Assets/Images/clients/BalakrushnaSwain_Director_nteGen.jpg";
import JungleeGames from "../../Assets/Images/clients/RahulBhardwaj_COO_JungleeGames.jpg";
import CashKaro from "../../Assets/Images/clients/SwatiBhargava_Cofounder_CashKaro.jpg";
import signupbackimage from "../../Assets/Svg/swati.jpg";
import quote from "../../Assets/Svg/quote.svg";
import "../../Module/SignUp/LeadSignup/LeadSignup.css";
import "./index.scss";
import sumHRLogo from "../../Assets/Images/sumHR-logo.svg";
import { getFormattedImageLink } from "../../Utils";

const clientData = [
  // {
  //   company: "NTE Gen",
  //   name: "Balakrushna Swain",
  //   position: "Director",
  //   message: "sumHR gets our big thumbs up as the top choice!",
  //   image: nteGen,
  // },
  // {
  //   company: "Junglee Games",
  //   name: "Rahul Bhardwaj",
  //   position: "COO",
  //   message:
  //     "I signed up for sumHR because of its user-friendly interface and customizable features",
  //   image: JungleeGames,
  // },
  // {
  //   company: "Cash Karo",
  //   name: "Swati Bhargava",
  //   position: "Co Founder",
  //   message:
  //     "We have had a wonderful experience since the time we began working with SumHR",
  //   image: CashKaro,
  // },
  {
    company: "Cash Karo",
    name: "Swati Bhargava",
    position: "Co Founder",
    message:
      "We have had a wonderful experience since the time we began working with SumHR",
    image: signupbackimage,
  },
];
function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}
class ClientsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptionData: props.clientData,
      client: {},
      randomInt: 0,
    };
  }

  getClientData = (data) => ({
    headertext: get(data, "headertext", ""),
    image: getFormattedImageLink(get(data, "bgimage", "")),
    subheadertext: get(data, "subheadertext", ""),
  });

  render() {
    const client = this.props.clientData
      ? this.getClientData(this.props.clientData)
      : clientData[this.state.randomInt];
    return (
      // <Grid container item xs={12} md={this.props.signup ? this.props.flag == 1 ? 6 : 3 : 6} sm={12} >
      <Grid
        container
        item
        xs={12}
        // md={8}
        md={
          this.props.signup
            ? this.props.flag == 1
              ? 8
              : 4
            : this.props.login
            ? 8
            : this.props.up
            ? 6
            : 8
        }
        sm={12}
        alignContent={!this.props.signup && "flex-end"}
        alignItems={!this.props.signup && "flex-end"}
        justify={!this.props.signup && "flex-end"}
        style={{
          backgroundImage: `url(${client.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className={!this.props.signup && "HRMSimplified-div"}
      >
        <div
          style={{
            width: "100%",
            // background: "rgb(152,153,151)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.5) 25%, rgba(0,0,0,0.7) 60%, rgba(0,0,0,1) 100%)",
          }}
        >
          <div style={{ margin: 32, objectFit: "cover" }}>
            <img src={quote} width="30" className="floatleft margin-right-16" />
            <div style={{ float: "left", width: "90%", marginBottom: 32 }}>
              <p
                className="text-color-white"
                style={{
                  fontWeight: "bold",
                  fontStyle: "italic",
                  fontSize: 22,
                  marginBottom: 24,
                  marginTop: "0",
                }}
              >
                {this.props.hrisLogin
                  ? client.subheadertext
                  : `${client.message}`}
              </p>

              <p
                className="small-dark-secondary t-bold text-color-white"
                style={{ opacity: 0.7 }}
              >
                {this.props.hrisLogin ? client.name : ``}
                {client.name}

                {this.props.hrisLogin
                  ? client.headertext
                  : `${" "}${client.position}, ${client.company}`}
              </p>
            </div>
          </div>
        </div>
      </Grid>
    );
  }
}
export default ClientsComponent;
